var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"at-userbar_loader at-inner-loaader"},[_c('span',[_c('i',{staticClass:"at-spinericon"})])])
}]

export { render, staticRenderFns }